import React from 'react';

export const WarningSquare = () => (
  <>
    <rect
      width="1081.1652"
      height="1081.1652"
      rx="180.1942"
      x="0"
      y="0"
      fill="#eda400"
    />
    <g
      transform="matrix(22.524275,0,0,22.524275,225.24275,261.37169)"
      fill="none"
    >
      <path d="m 12.685,2.858 a 2,2 0 0 1 3.43,0 L 26.983,20.971 A 2,2 0 0 1 25.268,24 H 3.532 A 2,2 0 0 1 1.817,20.971 Z" />
      <path
        fill="#fff"
        d="M 14.399999,3.8872948 3.5323792,21.999985 c -2e-6,4e-6 -3.9e-6,7e-6 -5.8e-6,1.1e-5 1.9e-6,0 3.8e-6,0 5.8e-6,0 H 25.267618 L 14.400008,3.8873062 c -2e-6,-3.8e-6 -4e-6,-7.6e-6 -6e-6,-1.14e-5 0,0 -2e-6,0 -3e-6,0 m 0,-2 c 0.663293,0 1.326584,0.3236713 1.714989,0.9710102 l 10.867621,18.112699 c 0.79982,1.333052 -0.160401,3.028992 -1.714991,3.028992 H 3.5323792 c -1.5545903,0 -2.5148106,-1.69594 -1.7149907,-3.028992 L 12.685009,2.858305 c 0.388405,-0.6473389 1.051697,-0.9710102 1.71499,-0.9710102 z"
      />
      <path
        fill="#fff"
        d="M 0,0 V 6.121 H 2.04 V 0 Z"
        transform="translate(13.38,9.45)"
      />
      <path
        fill="#fff"
        d="M 0,0 V 2.04 H 2.04 V 0 Z"
        transform="translate(13.38,17.611)"
      />
    </g>
  </>
);
